function padTwo(number: number): string {
	const result = "" + number;
	if (result.length === 1) {
		return "0" + number;
	}
	return result;
}

export default class Gregorian_Date {
	year: number;
	month: number;
	day: number;

	constructor(year: number, month: number, day: number) {
		if (month < 1) {
			throw new Error("expected a month bigger than 0");
		}
		if (month > 12) {
			throw new Error("expected a month smaller than 13");
		}
		if (day < 1) {
			throw new Error("expected a day bigger than 0");
		}
		if (day > 31) {
			throw new Error("expected a day smaller than 32");
		}

		this.year = year;
		this.month = month;
		this.day = day;
	}

	getYear(): number {
		return this.year;
	}

	getMonth(): number {
		return this.month;
	}

	getDay(): number {
		return this.day;
	}

	// don't add any other formatting here, it's not up this library to provide that.

	canonicalformat(): string {
		return this.year + "-" + padTwo(this.month) + "-" + padTwo(this.day);
	}
}
